import React from 'react'
import Input from '../form/Input'
import Very from '../../helpers/request_wrapper'
import Error from '../form/error'
import SelectInput from '../form/select'

class Index extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      first_name: this.props.user.first_name,
      last_name: this.props.user.last_name,
      email: this.props.user.email,
      company: this.props.user.company,
      country: this.props.user.country,
      disable: false,
      error: '',
    }
  }

  onCountrySelect = (value) => {
    const country = value.label;
    this.setState({country})
  };

  submit = (e) => {
    e.preventDefault();
    this.setState({ disable: true });

    Very.patch(`/users/${this.props.user.id}`, { user: this.state }).then(response => {
      window.location.replace('/')
    }, response => {
      this.setState({ error: response.error, disable: false })
    })
  };

  render() {
    const { error } = this.state;
    const countryList = this.props.countries.map(country => ({ label: country, value: country }));

    return (
      <React.Fragment>
        <div className="flex flex-center flex-justify-center mh-100vh" style={{ paddingTop: '80px' }}>
          <div className="col-12 md-px3 py-110 sm-py4" style={{ maxWidth: '350px' }}>
            <p className="title center mb-30">Profile</p>

            {error && <Error message={error} />}

            <form onSubmit={this.submit}>
              <div className="flex mb-20 mxn-10">
                <div className="col-6 px-10">
                  <Input
                    name="user[first_name]"
                    label="First Name"
                    onChange={(first_name) => this.setState({first_name})}
                    value={this.state.first_name}
                  />
                </div>

                <div className="col-6 px-10">
                  <Input
                    name="user[last_name]"
                    label="Last Name"
                    onChange={(last_name) => this.setState({last_name})}
                    value={this.state.last_name}
                  />
                </div>
              </div>

              <div className="mb-20">
                <Input
                  name="user[email]"
                  label="Email"
                  onChange={(email) => this.setState({email})}
                  value={this.state.email}
                />
              </div>

              <div className="mb-20">
                <Input
                  name="user[company]"
                  label="Company"
                  onChange={(company) => this.setState({company})}
                  value={this.state.company}
                />
              </div>

              <div className="mb-20">
                <SelectInput
                  className="react-select"
                  name="countries"
                  onChange={this.onCountrySelect}
                  options={countryList}
                  placeholder="Country"
                  required
                  value={this.state.country}
                />
              </div>

              <input
                type="submit"
                className="btn btn--primary col-12"
                value="Save"
                disabled={this.state.disable}
              />
            </form>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

export default Index;
